import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
};

const IconRecord: React.FC<Props> = ({
  width = 21,
  height = 20,
  color = "#3E3851",
  className = "fill-neutral-60 flex",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M8.11963 10.625V12.5C8.11963 12.6771 8.17956 12.8255 8.29942 12.9452C8.41914 13.0651 8.56762 13.125 8.74484 13.125C8.92206 13.125 9.07046 13.0651 9.19005 12.9452C9.30977 12.8255 9.36963 12.6771 9.36963 12.5V10.625H11.2446C11.4217 10.625 11.5701 10.5651 11.6898 10.4452C11.8097 10.3253 11.8696 10.1769 11.8696 9.99979C11.8696 9.82257 11.8097 9.67417 11.6898 9.55458C11.5701 9.43486 11.4217 9.375 11.2446 9.375H9.36963V7.5C9.36963 7.32292 9.3097 7.17451 9.18984 7.05479C9.06998 6.93493 8.92143 6.875 8.74421 6.875C8.56713 6.875 8.41873 6.93493 8.299 7.05479C8.17942 7.17451 8.11963 7.32292 8.11963 7.5V9.375H6.24463C6.06755 9.375 5.91907 9.43493 5.79921 9.55479C5.67949 9.67465 5.61963 9.82313 5.61963 10.0002C5.61963 10.1774 5.67949 10.3258 5.79921 10.4454C5.91907 10.5651 6.06755 10.625 6.24463 10.625H8.11963ZM4.00088 16.25C3.58005 16.25 3.2238 16.1042 2.93213 15.8125C2.64046 15.5208 2.49463 15.1645 2.49463 14.7435V5.25646C2.49463 4.83549 2.64046 4.47917 2.93213 4.1875C3.2238 3.89583 3.58005 3.75 4.00088 3.75H13.4882C13.909 3.75 14.2653 3.89583 14.5569 4.1875C14.8486 4.47917 14.9944 4.83549 14.9944 5.25646V9.07063L17.2855 6.77958C17.4067 6.65833 17.5439 6.62854 17.6971 6.69021C17.8505 6.75188 17.9271 6.86903 17.9271 7.04167V12.9583C17.9271 13.131 17.8505 13.2481 17.6971 13.3098C17.5439 13.3715 17.4067 13.3417 17.2855 13.2204L14.9944 10.9294V14.7435C14.9944 15.1645 14.8486 15.5208 14.5569 15.8125C14.2653 16.1042 13.909 16.25 13.4882 16.25H4.00088Z"
        fill="url(#paint0_linear_2442_683)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2442_683"
          x1="2.49463"
          y1="3.75"
          x2="14.7221"
          y2="18.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25" stop-color="#883CFF" />
          <stop offset="1" stop-color="#2F0F57" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconRecord;
